module.exports = __webpack_public_path__ + "img/outcomes.406ec540.svg";